// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifier{position:fixed;top:0;right:0;padding:10px;box-sizing:border-box;z-index:100000}.notifier__message{position:relative;float:right;margin-bottom:.625rem;border-radius:.25rem;max-width:250px;padding:22px;color:#fff;background:rgba(0,0,0,.75);font-size:14px;text-align:center;clear:both}.notifier__message.notifier__message--error{background:rgba(183,0,1,.75)}", ""]);
// Exports
module.exports = exports;
